
export type OptionValue               = { label: string , value: string | number, [key: string]: any }
export const optionValue: OptionValue = { label: 'label', value: 'value' }
